var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetch } from '@mitchell/typescript.service.fetch';
import { EnvironmentService, HttpCacheType, HttpContentType, HttpHeaderType, HttpMethodType } from "../../common";
import { handleResolveOrRejectResponse } from '../utilities';
export class PhotoCaptureContextService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
    }
    photoCaptureGetContextData(coCode, contextId) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `${EnvironmentService.getEnvironment().connectServicesUrl}v1.0/apd/photocapture/companies/${coCode}/apd/coCode/${coCode}/GPCContext/${contextId}`;
            const request = new Request(uri, {
                method: HttpMethodType.GET,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    accept: HttpContentType.APPLICATION_JSON,
                    Pragma: HttpCacheType.NO_CACHE
                })
            });
            const response = yield this.fetchWrapper(request);
            return yield handleResolveOrRejectResponse(response);
        });
    }
    photoCaptureUpdateContextData(contextDataUpdateInput, contextId, coCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `${EnvironmentService.getEnvironment().connectServicesUrl}v1.0/apd/photocapture/companies/${coCode}/apd/coCode/${coCode}/GPCContext/${contextId}`;
            const request = new Request(uri, {
                method: HttpMethodType.PUT,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    accept: HttpContentType.APPLICATION_JSON,
                    Pragma: HttpCacheType.NO_CACHE
                }),
                body: JSON.stringify(contextDataUpdateInput)
            });
            const response = yield this.fetchWrapper(request);
            return yield handleResolveOrRejectResponse(response);
        });
    }
    photoCapturePatchUpdateAttachmentContextData(attachmentRequest, contextId, coCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `${EnvironmentService.getEnvironment().connectServicesUrl}v1.0/apd/photocapture/companies/${coCode}/apd/coCode/${coCode}/GPCContext/${contextId}`;
            const request = new Request(uri, {
                method: HttpMethodType.PATCH,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    accept: HttpContentType.APPLICATION_JSON,
                    Pragma: HttpCacheType.NO_CACHE
                }),
                body: JSON.stringify(attachmentRequest)
            });
            const response = yield this.fetchWrapper(request);
            return yield handleResolveOrRejectResponse(response);
        });
    }
}
//# sourceMappingURL=PhotoCaptureContextService.js.map